module.exports = __webpack_public_path__ + "img/byd.acaf916e.png";